export enum AssetType {
	Drivers = 'DRIVERS',
	Trailers = 'TRAILERS',
	Trucks = 'TRUCKS',
};
